<template>
    <div>
        <!-- start bloc phone -->
        <template v-if="getPhone">
            <div>
            <li class="card-elm-item phone-info">
                <i class="icon icon-cards-phone"><span class="sr-only">Téléphone</span></i>
                <span>
                    {{ getPhone }}
                </span>
            </li>
            </div>
        </template>
        <!-- end bloc phone -->

        <!-- start bloc conventionnement secteur -->
        <li class="card-elm-item" v-if="cardData.tm_X3b_und_convention_type">
            <i class="icon icon-card"><span class="sr-only">Type de convention</span></i>
            <div class="labels">
            <span> {{ cardData.tm_X3b_und_convention_type[0] }} </span>
            </div>

        </li>
        <!-- end  bloc conventionnement secteur -->

        <!-- start bloc conventionnement secteur -->
        <li class="card-elm-item" v-if="cardData.bs_field_apf_survey_published">
            <i class="icon icon-accessibility"><span class="sr-only">informations relatives à l’accessibilité </span></i>
            <div class="labels">
            <span v-if="cardData.bs_field_apf_survey_published">{{ wording.labels.submitted }}</span>
            </div>
        </li>
        <li class="card-elm-item" v-if="cardData.bs_field_apf_survey_published && getlanguages">
            <i class="icon icon-bulles"><span class="sr-only">informations relatives aux langues </span></i>
            <div class="labels">
            <span v-if="getlanguages">{{ wording.labels.language }}
                <template v-for="(lang, index) in getlanguages">
                <template v-if="index !== 0 && index !== getlanguages.length - 1">,</template>
                <template v-else-if="index === getlanguages.length - 1 && getlanguages.length > 1 "> et </template>
                {{ lang }}
                </template>
            </span>
            </div>
        </li>
        <li class="card-elm-item" v-if="cardData.bs_field_apf_survey_published && (cardData.bs_field_apf_home_consultation || cardData.bs_field_apf_teleconsultation)">
            <i class="icon icon-home"><span class="sr-only">informations relatives à la téléconsultation </span></i>
            <div class="labels">
            <span v-if="cardData.bs_field_apf_home_consultation || cardData.bs_field_apf_teleconsultation">
                <template v-if="cardData.bs_field_apf_home_consultation">{{ wording.labels.homeConsultation }}</template>
                <template v-if="cardData.bs_field_apf_home_consultation && cardData.bs_field_apf_teleconsultation">
                <span class="to-lowercase">{{' et '+ wording.labels.teleConsultation }}</span>
                </template>
                <template v-else-if="cardData.bs_field_apf_teleconsultation">
                {{ wording.labels.teleConsultation }}
                </template>
            </span>
            </div>
        </li>
        <!-- end  bloc conventionnement secteur -->
    </div>
</template>

<script>
import { computed, ref } from 'vue';
import DrupalSettings from '@/services/legacy/api/DrupalSettings/searchFind';

export default {
  props: {
    cardData: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const wording = ref({
      labels: DrupalSettings.questionnaire.labels,
      languages: DrupalSettings.questionnaire.languages,
    });
    const getPhone = computed(() => {
      if (props.cardData.tm_X3b_und_field_phone_number) {
        return props.cardData.tm_X3b_und_field_phone_number[0];
      }
      if (props.cardData.tm_field_telephone_fixe) {
        return props.cardData.tm_field_telephone_fixe[0];
      }
      return null;
    });
    const getlanguages = computed(() => {
      if (wording.value.sm_field_apf_languages && wording.value.languages) {
        return props.cardData.sm_field_apf_languages.map((reponse) => Object.entries(wording.value.languages)
          .filter((element) => element[0] === reponse)
          .map((lang) => lang[1]))
          .flat();
      }
      return null;
    });
    return {
      wording,
      getPhone,
      getlanguages,
    };
  },
};
</script>
